// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"f5d4b50d","216":"fb0b5ad9","266":"b1214475","322":"ca36d82f","357":"13271fa5","610":"0a03fcc4","619":"41fde028","648":"a4597da6","668":"075a16dc","763":"fe3adc4b","774":"eda5f949","903":"9bc4945a","970":"273266cc","989":"e68f3228"}[chunkId] + ".chunk.js";
};